"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanActionStatuses = exports.LoanActions = exports.LoanTypes = exports.CalculatedLoanStatuses = exports.LoanStatuses = void 0;
// ***********************************************
//                     LOAN
// ***********************************************
exports.LoanStatuses = [
    'pending',
    'canceled',
    'initiated',
    'funded',
    'paid',
    // *** Edit Post Results ***
    'pendingEdit',
    'overriddenFromEdit',
    'canceledEdit',
];
exports.CalculatedLoanStatuses = ['overdue', ...exports.LoanStatuses];
exports.LoanTypes = ['origination', 'extension', 'rollover'];
// ***********************************************
//                  LOAN ACTION
// ***********************************************
exports.LoanActions = ['edit'];
exports.LoanActionStatuses = [
    'pending',
    'canceled',
    'approved',
    'rejected',
    'executed',
];
//# sourceMappingURL=Loans.js.map